import React, {useState} from 'react';
import {Button, Card, FormLayout, Text, TextField} from "@shopify/polaris";
import ToggleSwitch from "../../helper/ToggleSwitch";

const ExtraConfig = ({saveDataShopifyFn,formik}) => {
    const [showCartNoticeCustimizaion, setShowCartNoticeCustimizaion] = useState(false);

    return (
        <>
            <Card>
                <Text as="h2" variant="headingSm">
                    Pricing Rules
                </Text>
                <div
                    style={{marginTop: "1rem", display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                    <div>
                        <Text fontWeight="medium" as="p">
                            Auto switch currency based on IP Location
                        </Text>
                        <Text fontWeight="regular" as="p">
                            Customers from different countries will see the prices in their local currency by default
                        </Text>
                    </div>
                    <div>
                        <ToggleSwitch
                            value={formik.values.ipBasedLocation}
                            onChangeFn={() => {
                                formik.setFieldValue("ipBasedLocation",!formik.values.ipBasedLocation)
                            }}
                        />
                    </div>
                </div>
                <div
                    style={{marginTop: "1rem", display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                    <div>
                        <Text fontWeight="medium" as="p">
                            Remove Decimals
                        </Text>
                        <Text as="p">
                            Customers will see prices without decimal values.
                        </Text>
                    </div>
                    <div>
                        <ToggleSwitch
                            value={formik.values.removeDecimals}
                            onChangeFn={() => {
                                formik.setFieldValue("removeDecimals",!formik.values.removeDecimals)
                            }}
                        />
                    </div>
                </div>
                <div
                    style={{marginTop: "1rem", display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                    <div>
                        <Text fontWeight="medium" as="p">
                            Pricing Rounding Rules
                        </Text>
                        <Text as="p">
                            Customers will see prices with rounded decimal values.
                        </Text>
                    </div>
                    <div>
                        <ToggleSwitch
                            value={formik.values.pricingRound}
                            onChangeFn={() => {
                                formik.setFieldValue("pricingRound",!formik.values.pricingRound)
                            }}
                        />
                    </div>
                </div>
                <div
                    style={{marginTop: "1rem", display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                    <div>
                        <Text fontWeight="medium" as="p">
                            Show Actual Price On Hover
                        </Text>
                        <Text as="p">
                            Customers will show actual price on price hover.
                        </Text>
                    </div>
                    <div>
                        <ToggleSwitch
                            value={formik.values.showActualPriceOnHover}
                            onChangeFn={() => {
                                formik.setFieldValue("showActualPriceOnHover",!formik.values.showActualPriceOnHover)
                            }}
                        />
                    </div>
                </div>
                <div className="store-integration-message-div" style={{justifyContent:"end"}}>
                    <Button loading={formik.values?.pricingRuleLoader} onClick={() => {saveDataShopifyFn('pricingRuleLoader')}} size="large" variant="primary">save</Button>
                </div>
            </Card>
            <br/>
            <Card>
                <div style={{display: "flex", justifyContent: "space-between"}}>
                    <Text as="h2" variant="headingSm">
                        Cart Notice
                    </Text>
                    <ToggleSwitch
                        value={formik.values.showCartNotice}
                        onChangeFn={() => {
                            formik.setFieldValue("showCartNotice",!formik.values.showCartNotice)
                        }}
                    />
                </div>
                <TextField
                    label="Message"
                    value={formik.values.cartNoticeMessage}
                    onChange={(value) => formik.setFieldValue("cartNoticeMessage", value)}
                    multiline={4}
                    autoComplete="off"
                    suffix={
                        <div onClick={() => formik.setFieldValue("cartNoticeMessage", formik.values.defaultCartNoticeMessage)}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                color: "var(--p-color-text-link)"
                            }}>
                            <span>Set Default</span>
                        </div>}
                />
                <div onClick={() => {
                    setShowCartNoticeCustimizaion(!showCartNoticeCustimizaion)
                }} style={{color: 'var(--p-color-text-link)', cursor: "pointer", marginTop: "0.3rem"}}>
                    <Text fontWeight="regular" Tone='magic' as="h2" variant="headingMd">
                        Advance <div style={{
                        display: "inline-block",
                        transform: showCartNoticeCustimizaion && 'rotate(90deg)'
                    }}>></div>
                    </Text>
                </div>
                {showCartNoticeCustimizaion ?
                    <div style={{marginTop: "1rem"}}>
                        <FormLayout>
                            <FormLayout.Group condensed>
                                <TextField
                                    label="Text Hover Color"
                                    placeholder="Default"
                                    value={formik.values.cartNoticetextColor}
                                    suffix={
                                        <>
                                            <div style={{display: "flex", gap: "0.6rem"}}>
                                                <input
                                                    value={(formik.values.cartNoticetextColor === 'Default') ? '#ffffff' : formik.values.cartNoticetextColor}
                                                    onChange={(event) => formik.setFieldValue('cartNoticetextColor',event.target.value)}
                                                    style={{
                                                        appearance: "none",
                                                        inlineSize: "60px",
                                                        blockSize: '40px',
                                                        borderWidth: 0,
                                                        padding: 0,
                                                        background: "none"
                                                    }}
                                                    type="color"
                                                />
                                                <div onClick={() => formik.setFieldValue('cartNoticetextColor','#ffffff')} style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    cursor: "pointer",
                                                    color: "var(--p-color-text-link)"
                                                }}><span>Set Default</span></div>
                                            </div>

                                        </>
                                    }
                                />
                                <TextField
                                    label="Background Color"
                                    placeholder="Default"
                                    value={formik.values.cartNoticetextBackgroundColor}
                                    suffix={
                                        <>
                                            <div style={{display: "flex", gap: "0.6rem"}}>
                                                <input
                                                    value={(formik.values.cartNoticetextBackgroundColor === 'Default') ? '#ffffff' : formik.values.cartNoticetextBackgroundColor}
                                                    onChange={(event) => formik.setFieldValue('cartNoticetextBackgroundColor',event.target.value)}
                                                    style={{
                                                        appearance: "none",
                                                        inlineSize: "60px",
                                                        blockSize: '40px',
                                                        borderWidth: 0,
                                                        padding: 0,
                                                        background: "none"
                                                    }}
                                                    type="color"
                                                />
                                                <div onClick={() => formik.setFieldValue('cartNoticetextBackgroundColor','#333333')} style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    cursor: "pointer",
                                                    color: "var(--p-color-text-link)"
                                                }}><span>Set Default</span></div>
                                            </div>

                                        </>
                                    }
                                />
                            </FormLayout.Group>
                        </FormLayout>
                    </div>
                    : null}
                <div className="store-integration-message-div" style={{justifyContent:"end"}}>
                    <Button loading={formik.values?.cartNoticeLoader} onClick={() => {saveDataShopifyFn('cartNoticeLoader')}} size="large" variant="primary">save</Button>
                </div>
            </Card>
            <br/>
        </>
    );
};

export default ExtraConfig;
